<div
  *ngIf="!!component.config.headerHelperText"
  class="header-helper-content iris-mb-02"
  [ngClass]="component.config.styleClasses"
  [innerHTML]="component.config.headerHelperText | bindTemplate:response.data"
>
</div>

<h2
  *ngIf="!!component.config.heroText"
  class="hero-text-header"
  [ngClass]="{'no-bottom-margin': !component.config.helpText}"
  data-test="hero-header-text"
>
  {{ component.config.heroText | bindTemplate: response.data }}
  
  <div class="tooltip" *ngIf="!!component.config.tooltipHeaderDisplayText">
    <sonder-tooltip
      [desktopTooltipText]="component.config.tooltipHeaderBody"
    >
      <span displayText>{{component.config.tooltipHeaderDisplayText}}</span>
      <h2 mobileHeaderText>{{component.config.tooltipHeaderDisplayText}}</h2>
      <ng-container mobileBody>
        <p class="iris-body-responsive">
          {{component.config.tooltipHeaderBody}}
        </p>
      </ng-container>
    </sonder-tooltip>
  </div>
</h2>

<p
  *ngIf="showOptionalTextSlugs.has(component.slug)"
  class="hero-text-optional"
  data-test="hero-header-text-optional"
>
  (optional)
</p>
